<template>
  <div>
<section class="hero is-secondary skew">
  <div class="hero-body" style="padding-top: 6rem;">
    <div class="container">
            <div class="columns is-multiline">
  <div class="column is-10 is-offset-1 has-text-centered">
    <h2 class="is-size-3 is-size-4-mobile has-text-left-mobile script">{{ isGerman ? 'Projekte nach Themen' : 'Projects by topic' }}</h2>
  </div> 
  <div class="column is-10 is-offset-1 has-text-centered">


            <div class="field is-grouped is-grouped-multiline" style="display: flex; justify-content: center;">
                            <div class="control" >
                <div class="tags has-addons">
                  <span @click="filter" class="tag is-rounded is-medium cursor has-text-weight-bold" style="border: 1px solid white;color:white;background-color:transparent;"><span class="icon"><i class="fa fa-check" v-if="!filterContent"></i><i class="fa fa-close" v-else></i></span>&nbsp;{{ isGerman ? 'Alle anzeigen' : 'Show all' }}</span>
                </div>
              </div>
              <div v-for="(i, index) in allTags" :key="index" class="control">
                <div class="tags has-addons">
                  <span @click="filterBy(i)" class="tag is-rounded is-medium is-white cursor has-text-weight-bold" :class="[ {'is-primary' : (filterContentBy.indexOf(i) !== -1)}, 'tag_' + i, (isGerman ? 'tag_' : 'tagen_') + i ]"></span>
                </div>
              </div>
            </div> 


  </div>
  <div class="column is-12">

    <app-projects-overview :content="content"></app-projects-overview>

          <div class="columns is-multiline">
          <div class="column is-12 has-text-centered" v-if="content.length===0"><p class="title is-5"><span class="icon"><i class="fa fa-info-circle"></i></span>&nbsp;Keine Ergebnisse zu der Auswahl<br><a @click="filter" class="title is-7 is-underlined">Filter deaktivieren</a></p>
          </div>
        </div>


</div>

</div>
    </div>
  </div>
</section>
</div>
</template>

<script>
import ProjectsOverview from '@/components/shared/ProjectsOverview'
export default {
  data () {
    return {
    }
  },
  methods: {
    filter () {
      this.$store.dispatch('filterContent')
    },
    filterBy (v) {
      this.$store.commit('filterContentBy', v)
    }
  },
  computed: {
    allTags () {
      return this.$store.getters.allTags
    },
    filterContentBy () {
      return this.$store.getters.filterContentBy
    },
    filterContent () {
      return this.$store.getters.filterContent
    },
    content () {
      if (this.filterContent === false) {
        return this.$store.getters.content.filter(el => el.type === 1) // zeige nur Projekte
      } else {
        return this.$store.getters.content.filter(el => el.type === 1 && this.filterContentBy.some(s => el.content.tags.indexOf(s) !== -1))
      }
    },
    isGerman () {
      return this.$store.getters.isGerman
    }
  },
  components: {
    appProjectsOverview: ProjectsOverview
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Projects.vue